import React, { useState, useEffect, JSX } from "react";
import Alert from "@mui/material/Alert";
import useSystemTimeCheck from "../hooks/useSystemTimeCheck";

const SystemTimeWarning = (): JSX.Element | null => {
  const issue = useSystemTimeCheck();
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    setClosed(false);
  }, [issue]);

  if (!issue || closed) {
    return null;
  }

  const message =
    issue === "timezone"
      ? "Incorrect timezone. Please set your computer timezone to Asia/Kathmandu (UTC+05:45)."
      : "Incorrect date or time. Please correct your computer's date and time before continuing.";

  return (
    <Alert
      severity="error"
      variant="filled"
      onClose={() => setClosed(true)}
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        borderRadius: 0,
        minHeight: 40,
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,

        "& .MuiAlert-message": {
          flex: 1,
          textAlign: "center"
        }
      }}
    >
      {message}
    </Alert>
  );
};

export default SystemTimeWarning;
